const isMobile = () => {
  let isMobileMode = false;
  // #!if mobile === true
// isMobileMode = true;
  // #!endif
  return isMobileMode;
};

const isTablet = () => {
  let isTabletMode = false;
  // #!if tablet === true
// isTabletMode = true;
  // #!endif
  return isTabletMode;
};

const isIos = () => {
  return isMobile() || isTablet();
};

const isDesktop = () => {
  let isDesktopMode = false;
  // #!if desktop === true
  isDesktopMode = true;
  // #!endif
  return isDesktopMode;
};

const isHarvard = () => {
  let isHarvardMode = false;
  // #!if harvard === true
  isHarvardMode = true;
  // #!endif
  return isHarvardMode;
};

const isReadonly = () => {
  let isReadonlyMode = false;
  // #!if readonly === true
  isReadonlyMode = true;
  // #!endif
  return isReadonlyMode;
};

export default {
  isMobile,
  isTablet,
  isIos,
  isDesktop,
  isHarvard,
  isReadonly
};
